import React from "react";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import FollowupsListingWrapper from "../Followups/List/FollowupsListingWrapper";
import { Link } from "react-router-dom";

type Props = {
  columns: columnTypes[];
  rows: any[];
  isTableLoading: boolean;
  totalItems: number;
  limit: number;
};

const DueAmountListing = ({
  columns,
  rows,
  isTableLoading,
  totalItems,
  limit,
}: Props) => {
  const showViewAll = !isTableLoading && totalItems > limit;

  return (
 
      <div className="flex flex-col p-4">
        <ATMPageHeader
        moduleName="ORDER"
          pageTitle="Order dues"
          hideAddButton
          hideSearchBox
        />

        {/* Table */}
        <div className="flex-1 overflow-auto flex flex-col">
          <ATMTable
            columns={columns}
            rows={rows}
            // rowExtraClasses={() => 'min-h-[40px]'}
            isLoading={isTableLoading}
          />
        </div>
        {showViewAll && (
          <Link className="text-center mt-2 text-blue-500" to="/dues">
            view_all
          </Link>
        )}
        {/* <div className='p-4 py-2'>
        <ATMPagination
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={setPage}
          onRowsPerPageChange={setRowsPerPage}
          rowCount={totalItems}
          rows={rows}
        />
      </div> */}
      </div>
  
  );
};

export default DueAmountListing;
